module.exports = require('./src/normalizeWheel.js');



//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/normalize-wheel/index.js
// module id = 1355
// module chunks = 0